import React from 'react';
import testimonials from './testimonials';
import {INTERVAL, FADE_OUT_ANIMATION_TIME, FADE_IN_ANIMATION_TIME} from './config';
import './index.scss';

class SocialProof extends React.PureComponent {
  constructor(props) {
    super(props);
    this.rotateSocialProof = this.rotateSocialProof.bind(this);
    this.currentIdx = 0;
  }

  rotateSocialProof = () => {
    this.intervalID = setInterval(() => {
      const {currentIdx, socialProofContainer} = this;
      const testimonials = socialProofContainer.children;
      const nextIdx = currentIdx + 1 !== testimonials.length ? currentIdx + 1 : 0;

      testimonials[currentIdx].classList.add('fadeOut');
      setTimeout(() => {
        testimonials[currentIdx].classList.add('hide');
        testimonials[currentIdx].classList.remove('fadeOut');

        testimonials[nextIdx].classList.remove('hide');
        testimonials[nextIdx].classList.add('fadeIn');
        setTimeout(() => testimonials[nextIdx].classList.remove('fadeIn'), FADE_IN_ANIMATION_TIME);
      }, FADE_OUT_ANIMATION_TIME);

      this.currentIdx = nextIdx;
    }, INTERVAL);
  }

  componentDidMount() {
    this.rotateSocialProof();
  }

  componentWillUnmount() {
    clearInterval(this.intervalID);
  }

  render() {
    return (
      <div className="SocialProof__container" ref={(spc) => this.socialProofContainer = spc} >
        {testimonials.map(
          ({testimonial, name, location, category, image}, idx) => (
            <div className={`SocialProof__testimonialContainer ${idx ? 'hide' : ''}`} key={`${name}-${idx}`}>
              <div className="SocialProof__sellerTestimonial">
                <div className="SocialProof__testimonial">
                  <blockquote className="SocialProof__blockquote">
                    {testimonial}
                  </blockquote>
                </div>                
              </div>
          
              <div className = "SocialProof__sellerInfo">
                {image && (
                  <div className="SocialProof__sellerImage" style={{backgroundImage: `url(${image}`}}></div>
                )}
                <span className="SocialProof__sellerName">
                  {name}
                </span>
                <span className="SocialProof__sellerLocation">
                  - {location}
                </span>
              </div>
          
              <div className="SocialProof__sellerCategory">
                {category}
              </div>
            </div>
          )
        )}
      </div>
    );
  }
}

export default SocialProof;
